/* @jsxImportSource react */
export type CustomerRatingMeterProps = {
  portion: number;
};

/**
 * The CustomerRatingMeter component displays a visual meter representing the portion of ratings
 *
 * @param portion - The portion value (0-100) to be represented by the meter
 */
export const CustomerRatingMeter = ({ portion }: CustomerRatingMeterProps) => (
  <figure
    role="meter"
    aria-valuemax={100}
    aria-valuemin={0}
    aria-valuenow={portion}
    className="bg-color-grey-light overflow-hidden rounded-sm"
  >
    <div className="bg-color-grey-dark h-1.5" style={{ width: `${portion}%` }} />
  </figure>
);
